import { neverExpires, useDismissibleBanner } from '../../../hooks/useDismissibleBanner';
import { usePrerenderUserId } from '../../../hooks/usePrerenderUser';
import {
  CRAWLER_PICKER_ANNOUNCEMENT_STORAGE_KEY_PREFIX,
  isCrawlerPickerAnnouncementRetired,
} from './CrawlerPickerAnnouncementRules';

export type CrawlerPickerAnnouncementVisibility = {
  visible: boolean;
  dismiss: () => void;
};

export function useCrawlerPickerAnnouncement(): CrawlerPickerAnnouncementVisibility {
  const userId = usePrerenderUserId();
  const { isDismissed, dismiss } = useDismissibleBanner(
    CRAWLER_PICKER_ANNOUNCEMENT_STORAGE_KEY_PREFIX,
    userId,
    neverExpires
  );

  return { visible: !isDismissed && !isCrawlerPickerAnnouncementRetired(Date.now()), dismiss };
}
